import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxWrapperSharedModule } from './ngx-wrapper-shared/ngx-wrapper.shared.module';
import { NgxManageLayoutModule } from './ngx-manage-layout/ngx-manage-layout.module';

const modules = [
  NgxWrapperSharedModule,
  NgxManageLayoutModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...modules
  ],
  exports: [...modules]
})
export class NgxWrapperModule { }
